import { shareReplay } from 'rxjs/operators';

/**
 * an custom operator to emulate the most common shareReplay() use-case (refCount = true and bufferSize = 1)
 * same as writing "shareReplay(1)"" in older versions of RxJs. its emitting the last value emitted to any
 * consumer without creating new subscriptions
 */
export function shareReplayLast<T = unknown>() {
  return shareReplay<T>({ refCount: true, bufferSize: 1 });
}
